<!--
 * @Author: your name
 * @Date: 2021-01-18 16:39:34
 * @LastEditTime: 2021-01-18 17:17:40
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: /huzhu-zymutual2/src/pages/portal/private/headerContent.vue
-->
<template>
  <div class="meHeaderBox">
    <div class="headerContent clearfix">
      <div class="box-left clearfix">
        <router-link to="/" class="logoImg">
          戏游互动
        </router-link>
        <div @click="tabClick(1)" :class="{ tabAct: leftType == 1}" class="headerTxt">个人中心</div>
        <div @click="tabClick(2)" :class="{ tabAct: leftType == 2}" class="headerTxt">账号设置</div>
      </div>
      <router-link to="#" class="shoppingCar">购物车</router-link>
    </div>
  </div>
</template>
<script>
  export default {
    props: ['leftType'],
    methods: {
      tabClick (type) {
        this.$emit('update:leftType', type)
        if(type == 1){
          this.$router.push({
            path: 'meDetails'
          })
        }else {
          this.$router.push({
            path: 'editUser'
          })
        }
      }
    }
  }
</script>
<style scoped>
  .meHeaderBox{
    background-color: #fff;
    width: 100%;
  }
  .headerContent{
    width: 1200px;
    margin: 0 auto;
    padding: 20px 0;
  }
  .tabAct{
    color: #3F8FDF;
  }
  .box-left{
    float: left;
  }
  .logoImg{
    width: 120px;
    height: 70px;
    display: block;
    float: left;
    font-family: PingFangSC-Medium, PingFang SC;
    color: #66beb2;
    font-size: 20px;
  }
  .headerTxt{
    margin-left: 40px;
    font-size: 16px;
    height: 70px;
    line-height: 70px;
    float: left;
    cursor: pointer;
  }
  .headerTxt:hover{
    color: #3F8FDF
  }
  .shoppingCar{
    display: block;
    height: 38px;
    line-height: 38px;
    border: 1px solid #f1f1f1;
    font-size: 14px;
    margin: 15px 0;
    padding: 0 20px;
    float: right;
  }
</style>



// WEBPACK FOOTER //
// src/pages/portal/private/headerContent.vue